// extracted by mini-css-extract-plugin
export default {"breadcrumb":"breadcrumb_breadcrumb__DnUSh","isClickable":"breadcrumb_isClickable__f+UAX","active":"breadcrumb_active__C0Nsx"};